import Loader from "react-loader-spinner";
import { COLORS } from "../constants/Colors";

function LoadingSpinnerCover() {
  return (
    <div className="d-flex container h-100 justify-content-center align-items-center vh-100">
      <div className="">
        <Loader
          type="Puff"
          color={COLORS.iStaffGreen}
          height={100}
          width={100}
        />
      </div>
    </div>
  );
}

export default LoadingSpinnerCover;
